import { useEffect, useState } from "react";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { useNavigate } from "react-router-dom";

const DBADomainMappings = ({ selectedDba }: any) => {
  const navigate = useNavigate()
  const [columnDefs, setColumnDefs] = useState({});
  const [refreshKey, setRefreshKey] = useState(0);

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'DBADomainName', headerName: 'DBA Domain Name', sortable: true, filter: true, filterType: 'text',
        // callback: handleEditDBNDomain 
      },
      { field: 'DBADomainCode', headerName: 'DBA Domain Code', sortable: true, filter: true, filterType: 'text' },
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Domain Mapping</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleAdd = () => {
    navigate(`/management/dbn-cloud/dbn-taxonomy/dbn-domains/${0}`)
  }

  const handleEditDBNDomain = (data: any) => {
    navigate(`/management/dbn-cloud/dbn-taxonomy/dbn-domains/${data?.DBADomainCode}`)
  }

  const handleReloadData = () => {
    setRefreshKey(prev => prev + 1);
  };

  useEffect(() => {
    createColumnDefs();
  }, [selectedDba])

  return (
    <>
      {selectedDba?.isLoading ? <PageLoader /> :
        <Table
          key={refreshKey}
          columnData={columnDefs}
          rowData={selectedDba?.DBATaxonomies}
          enableFilter={true}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="DBA Domain Mappings"
        />
      }
    </>
  );
};

export default DBADomainMappings;


